export const pingPongRate: number = 1500;
export const heartBeatRate: number = 15000;
export const packetsUpdateRate: number = (1 / 30) * 1000;
